<template>
  <div>
    <el-button type="success" style="margin-bottom: 5px;margin-left: 5px" @click="addGoodsTry">
      添加学科<i class="el-icon-upload el-icon--right"></i>
    </el-button>
    <el-table
        :data="tableData"
        border
        stripe
        style="width: 100%">
      <el-table-column
          prop="ID"
          label="ID"
          width="80">
      </el-table-column>
      <el-table-column
          prop="Name"
          label="学科名称">
      </el-table-column>

      <el-table-column
          label="操作"
          width="120">
        <template slot-scope="scope">
          <el-button @click="cGoods(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
        title="添加学科"
        :visible="addGoodsVisible"
        width="30%"
        center
        :before-close="addGoodsTryClose"
    >
      <el-form :model="addGoodsForm">
        <el-form-item label="学科名称" >
          <el-input v-model="addGoodsForm.name" autocomplete="off" placeholder="计算机类"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="addGoods">确定</el-button>
      </div>

    </el-dialog>



  </div>
</template>

<script>
import http from "@/utils/http-base";
export default {
  name: "admin-lanmu",
  data(){
    return{
      tableData: [],
      addGoodsVisible: false,
      addGoodsForm:{
        name:"",
      },

    }
  },
  methods:{
    addGoodsTry() {
      this.addGoodsVisible = true
    },
    addGoods() {
      http.post("/api/down/xuekeadd", {
        name:this.addGoodsForm.name,
      },).then(res=>{
        if (res.data.code ===0){
          this.$message({
            message: '恭喜你，添加成功',
            type: 'success'
          });
          this.addGoodsVisible = false
          this.getGoods()

        }else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getGoods() {
      http.get("/api/down/xueke", ).then(res=>{
        if (res.data.code ===0){
          this.tableData=res.data.data
        }else {
          this.$message.error(res.data.msg)
        }
      })
    },
    cGoods(name) {
      console.log(name,123)
      http.post("/api/down/xuekedel",{"name":name.Name}, ).then(res=>{
        if (res.data.code ===0){
          this.$message({
            message: '操作成功!',
            type: 'success'
          });
          this.getGoods()
        }else {
          this.$message.error(res.data.msg)
        }
      })
    },

    addGoodsTryClose(){
      this.addGoodsVisible = false
    },
  },
  mounted() {
    this.getGoods()
  }

}
</script>

<style scoped>

</style>